import { render, staticRenderFns } from "./HdCarousel.vue?vue&type=template&id=135941f8&scoped=true&"
import script from "./HdCarousel.vue?vue&type=script&lang=js&"
export * from "./HdCarousel.vue?vue&type=script&lang=js&"
import style0 from "./HdCarousel.vue?vue&type=style&index=0&id=135941f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135941f8",
  null
  
)

export default component.exports